export const DEFAULT_ICON_PREFIX = 'icon'
